import { render, staticRenderFns } from "./dashboard-filters.vue?vue&type=template&id=7cd5f253&scoped=true&lang=pug&"
import script from "./dashboard-filters.vue?vue&type=script&lang=ts&"
export * from "./dashboard-filters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd5f253",
  null
  
)

export default component.exports